import React, { useMemo, useRef } from 'react';
import { ContextMenu } from 'Views/Components/ContextMenu/ContextMenu';
import useStore from 'Hooks/useStore';
import { contextMenu } from 'react-contexify';
import { logout } from 'Util/NavigationUtils';

const NavbarUserDropdown = () => {
	const store = useStore();
	const userDropdownRef = useRef<HTMLDivElement>(null);

	const getContextMenuPosition = () => {
		if (!userDropdownRef.current) {
			return null;
		}

		const { x, y } = userDropdownRef.current.getBoundingClientRect();
		const height = userDropdownRef.current.offsetHeight;

		return {
			x: x + 30,
			y: y + height + 10,
		};
	};

	const userName = useMemo(() => {
		if (store.firstName && store.lastName) {
			return `${store.firstName} ${store.lastName}`;
		}

		if (store.email) {
			return store.email.split('@')[0];
		}

		return 'User';
	}, [store]);

	return (
		<div ref={userDropdownRef} className="navbar-user-dropdown">
			<button
				className="btn txt-sm-body context-btn"
				onClick={e => contextMenu.show({
					id: 'user-dropdown-menu',
					event: e,
					position: getContextMenuPosition(),
				})}
			>
				{userName}
			</button>
			<ContextMenu
				menuId="user-dropdown-menu"
				actions={[
					{
						label: 'Log out', icon: 'exit-to-app', iconPos: 'icon-left', onClick: () => logout('/'),
					},
				]}
			/>
		</div>
	);
};

export default NavbarUserDropdown;
